module.exports = __webpack_public_path__ + "img/wedo_pict01.a21c04c3.png";